import { useState, useEffect } from 'react';
import { currencyService } from '../services/currencyService';
import { OrganizationCurrencySettings, formatCurrency } from '../types/currency';

export const useCurrency = (organizationId: string) => {
  const [settings, setSettings] = useState<OrganizationCurrencySettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        setLoading(true);
        setError(null);
        const orgSettings = await currencyService.getOrganizationCurrencySettings(organizationId);
        setSettings(orgSettings);
      } catch (err) {
        console.error('Erreur lors du chargement des paramètres de devise:', err);
        setError('Erreur lors du chargement des paramètres de devise');
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [organizationId]);

  const format = (amount: number): string => {
    if (!settings) {
      return `${amount.toFixed(2)} €`; // Fallback par défaut
    }
    return formatCurrency(amount, settings);
  };

  return {
    settings,
    loading,
    error,
    format
  };
};